/**
 * dance.ts
 * Danceカードの定義
 * ダンスを選択してロボットに踊らせるノード
 */
import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { DanceNodeView } from '../views/DanceNode';
import { DanceSettings } from '../settings/DanceSettings';
import { DEFAULT_DANCE_MOTION_ID, getDanceLabel } from '../../config/danceMotions';
import { runMotionCard } from './motionCardRun';

/** ダンスは最長で約43秒あるため Gesture より長くとる */
const VIRTUAL_DANCE_TIMEOUT_MS = 60000;

/**
 * Danceカードの定義
 * - パレットに表示してユーザーがドラッグ配置できる
 * - 実行時は選択されたダンスをロボットに送信
 * - 選択肢は danceMotions.json で管理
 */
export const danceDefinition: NodeDefinition<'dance'> = {
  label: 'Dance',
  showInPalette: true, // パレットに表示
  paletteColor: 'bg-rose-100 border-rose-500 text-rose-700',
  miniMapColor: '#f43f5e', // ローズ
  defaultData: { label: 'Dance', motionId: DEFAULT_DANCE_MOTION_ID }, // デフォルトは設定ファイル先頭
  view: DanceNodeView,
  settings: DanceSettings,
  run: (node, ctx, log) => runMotionCard(
    {
      logTag: 'Dance',
      nodeKind: 'dance',
      nodeId: node.id,
      motionId: node.data.motionId,
      motionLabel: getDanceLabel(node.data.motionId) ?? '（未設定）',
      virtualTimeoutMs: VIRTUAL_DANCE_TIMEOUT_MS,
    },
    ctx,
    log,
  ),
  help: {
    title: [t('Dance（'), r('踊', 'おど'), t('る）')],
    description: [
      r('選', 'えら'),
      t('んだダンスを、ロボットが'),
      r('踊', 'おど'),
      t('ります。'),
      r('踊', 'おど'),
      t('り'),
      r('終', 'お'),
      t('わってから、つぎのカードへ'),
      r('進', 'すす'),
      t('みます。'),
    ],
  },
};
